import jsBridge from './index'
/**
 * 通过jsBridge的weixinShareImage方法修改app导航条名称
 * @param {String} shareType  0：分享朋友 /1：分享朋友圈
 * @param {String} imageUrl 图片链接
 */
export default function weixinShareImage(options = {}) {
  const { shareType = '', imageUrl = '' } = options
  return jsBridge('weixinShareImage', {
    shareType,
    imageUrl
  })
}
